import axios from 'axios';
import {ConstService} from "@/service/ConstService";
import {API_ENDPOINTS} from "@/global/api/config/api-endpoints";
import {defaultApiClient} from "@/global/api/default-api";

// 토큰 갱신용 별도 인스턴스 생성
/*export const refreshTokenApiClient = axios.create({
    baseURL: API_ENDPOINTS.BASE,
    withCredentials: true,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});*/
export const refreshTokenApiClient = axios.create({
    baseURL: API_ENDPOINTS.BASE,
    withCredentials: true,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

export default refreshTokenApiClient;